import { SagaIterator } from "redux-saga";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { IResponse } from "../../../../libs/requester/IResponse";
import { requester } from "../../../../libs/requester/requester-axios";
import {
  setActionLoading,
  setAnnoucementCount,
  setDocumentCount,
  updateAllComments,
  updateCommentById,
} from "../../repository/slice";
import { getDocumentCount } from "../getDocumentsCount/action";
import { getAnnoucementCount } from "../getAnnoucementCount/action";
import toast from "react-hot-toast";
import i18next from "i18next";
import { tokens } from "../../../../locales/tokens";

function* readCommentWorker({ payload }: any): SagaIterator {
  const { id, all, type } = payload;

  const url =
    all === undefined
      ? `/api/admin/comments/${id}/read`
      : type === "document"
      ? `/api/admin/document-comments/${id}/read`
      : `/api/admin/announcement-comments/${id}/read`;

  try {
    yield put(setActionLoading(true));

    const comments = yield select(({ comments }) => comments.comments);
    const documentCount = yield select(
      ({ comments }) => comments.documentCount
    );
    const annoucementCount = yield select(
      ({ comments }) => comments.annoucementCount
    );

    const comment = comments.find((c: any) => c.id === id);

    const { data, message, isError }: IResponse<any> = yield call(
      requester.patch,
      url
    );

    if (!isError) {
      if (all !== undefined) {
        yield put(updateAllComments({ isReadByAdmin: true }));

        if (type === "document") {
          yield put(getDocumentCount());
        } else {
          yield put(getAnnoucementCount());
        }
        toast.success(i18next.t(tokens.comments.successAllRead));
      } else {
        yield put(
          updateCommentById({
            id,
            changes: { isReadByAdmin: true },
          })
        );
        if (type === "document") {
          yield put(setDocumentCount(documentCount - 1));
        } else {
          yield put(setAnnoucementCount(annoucementCount - 1));
        }
        toast.success(i18next.t(tokens.comments.successRead));
      }
    } else {
      console.error(message);
    }
  } catch (error) {
    console.error("readCommentWorker: ", error);
  } finally {
    yield put(setActionLoading(false));
  }
}

export function* readCommentWatcher() {
  yield takeLatest("@saga/READ_COMMENT", readCommentWorker);
}
